<template>

<div class="pc_only">
       <h2 class="kojin-title">
        {{title}}</h2>
     </div>
     
     <span class="sp_only">
       <span class="sp-title" style="color:#FFF;background: #4169e1;">
           {{title}}
          <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
         </span>
       </span>

       
       <div  align='left' style='margin:20px; background-color: #f0ebf8;padding: 3%;'>
        
            <div  v-if="results.title != ''"   class="title_set form-check form-check-inline">
                <font size="6pt"><b>{{ results.title }}</b></font><br/>
            </div>
            <br>
            <div v-if="results.sub_title != ''"  class="title_set form-check form-check-inline" style="font-size:0.95rem">
                <b>{{ results.sub_title }}</b><br/>
            </div>

          
            <!--ここからパーツ-->
            <div v-for="part in allparts" :key="part.kind" class="answer_area">
                <div v-if="part.kind=='title_large'" class="title_set form-check form-check-inline">
                <font size="6pt"><b>{{ part.label }}</b></font><br/>
                </div>
                <div v-if="part.kind=='title'" class="title_set form-check form-check-inline" style="font-size:0.95rem">
                    <b>{{ part.label }}</b><br/>
                </div>
                
                <div v-if="part.kind=='image'" class="section_area form-check form-check-inline">
                    <b>{{ part.label }}</b> <b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                    <span v-for="image in part.option" :key="image">
                        <input type='file' :id="image.seq+','+image.image_index" :name="part.image_index" accept="image/*" v-on:change="imgUpload" style="margin:5px 0" /><br/>
                    </span>
                </div>
                <div v-if="part.kind=='text'" class="section_area form-check form-check-inline">
                    <b>{{ part.label }}
                          <template v-if="part.mojisu != 0" >
                         （{{part.mojisu}}文字以上）
                        </template>
                    </b>
                    <b v-if="part.hissu == 1" style="color:red">（必須）</b>
                    <br><textarea cols="40" rows="3"  v-model="part.value" class="form-control" ></textarea>
                    <template v-if="part.mojisu != 0 " >
                        <template v-if="part.value.length >= part.mojisu">
                            <!--文字数指定を満たした場合は「0」で止める（負の整数にしないこと）-->
                            残り0文字
                        </template>
                        <template v-else>
                            <!--文字が入力されていて、文字数指定を満たさない場合は「文字数指定－現在の文字数＝残り文字数」-->
                            残り{{part.mojisu - part.value.length}}文字
                        </template>
                    </template>
                </div>
                <div v-if="part.kind=='date'" class="section_area form-check form-check-inline">
                    <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                    <br><input type="date" size="20"  v-model="part.value" class="form-control" /><br/>
                </div>
                <div v-if="part.kind=='time'" class="section_area form-check form-check-inline">
                    <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                    <br><input type="time" size="20"  v-model="part.value" class="form-control" /><br/>
                </div>
                
                <div v-if=" part.kind=='radio_title'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                <br>
                
                <div v-for="radio in part.option" :key="radio">
                    <input type="radio" class="form-check-input" v-on:change="setRadio(radio,part)" :name="part.seq" style="margin-left:0.5rem">
                    <label :for="'radio-' + radio.id">{{ radio.label }}</label>
                    
                    <div style="margin-left:15px" v-if="radio.child[0] == 'text'">
                            <div style="margin-left:15px">
                                <span v-if="radio.child[2] == 1">
                                    <b>{{ radio.child[1] }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                                    <input type="text" style="width:95%" class="form-control" v-model="radio.child[3]" v-on:change="setRadioIreko(radio,part,radio.child[3])">
                                    <!--
                                    // そのラジオボタンのオプション（選択肢配列）を確認
                                    for (let p=0;p<allparts.value[a].option.length;p++) {
                                        // その選択肢に入れ子が存在するかチェック
                                        if(allparts.value[a].option[p].child[0] == 'text'){
                                            // 選択肢のセクションNo.なら、入れ子を表示
                                            if(radio_seq == allparts.value[a].option[p].seq){
                                                allparts.value[a].option[p].child[2] = 1
                                            }else{
                                                allparts.value[a].option[p].child[2] = 0

                                            }
                                        }
                                    }
                                    -->
                                </span>
                            </div>
                    </div>
                </div>
                
                </div>

                <div v-if="part.kind=='check_title'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                <br>
                
                <div v-for="check in part.option" :key="check">
                    <input type="checkbox" class="form-check-input" v-on:change="setCheckbox(check,part)" :name="part.seq"  v-model="check.sentaku" style="margin-left:0.5rem">
                    <label :for="'checkbox-' + check.id">{{ check.label }}</label>
                    
                    <div style="margin-left:15px" v-if="check.child[0] == 'text'">
                            <div style="margin-left:15px">
                                <span v-if="check.child[2] == 1">
                                    <b>{{ check.child[1] }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                                    <input type="text" v-if="check.child[0] == 'text' "  style="width:95%" class="form-control" v-model="check.child[3]" v-on:change="setCheckIreko(check,part,check.child[3])">
                                </span>
                            </div>
                    </div>
                </div>
                </div>
                <div v-if="part.kind=='pulldown'" class="section_area form-check form-check-inline">
                    <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                    <select class="form-select" v-on:change="setPulldown(part.index)"  v-model="part.selectedIndex">
                        <option v-for="(op,opIndex) in part.option" :value="opIndex" :key="op">{{op}}</option>
                    </select>
                    
                </div>
            </div>
            <!--ここまでパーツ-->
          
            <div v-if="results.footer != ''"  class="title_set form-check form-check-inline" style="font-size:0.95rem">
                <b>{{ results.footer }}</b><br/>
            </div>
        </div>
        <div style="width: 100%;text-align: center;">
            <button  class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="teishutsu_kakunin" v-if="teishutsu_flg == 0" >提出する</button>
        </div>
                 
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                v-on:call="call"
                v-on:close_message="Close_message"
                v-on:ok_message="OK_message"/>

  </template>
  
  <script setup>
  /* eslint-disable */
    import { ref } from 'vue';
    import { GlobalData, DateSetting,TimeSetting,DateTimeSetting,login_check } from '../js/userdata.js'
    import AWS from 'aws-sdk';
    
    import { useRouter,useRoute } from 'vue-router'
    import axios from 'axios'
    const url = GlobalData.$API_URL
    const router = useRouter();
    const route = useRoute();

    /* メッセージを表示するモーダルウィンドウ */
    import MessageModal from '../common/MessageModal.vue'  

  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント

//  const mode = ref('read');
  const ans_text = ref('');
  const ans_date = ref('');
  const ans_time = ref('');
  const ans_checkbox = ref([]);
  const ans_radio = ref('on');
  const ans_pulldown = ref('');
  const ans_childcheck = ref([]);
  const ans_childradio = ref([]);
  let allparts = ref([]);

  
// 親コンポーネントへ送るemit
const emit = defineEmits(['call'])

// 親コンポーネント（User.vue）から送られてきた値
const props = defineProps(['param']);

//param = {'results':results,"syurui":form_syurui,"no":form_no,"program_id":program_id}

let results = props.param.results
let title = "活動報告書の提出"
let form_no = props.param.no
//alert(form_no)
let form_syurui = props.param.syurui
let form_syurui_text = "report"
let program_id = 0
let moshikomi_count = props.param.moshikomi_count
console.log(moshikomi_count)

  if(form_syurui == 1){
    form_syurui_text = "enqete"
    title = "アンケート提出"
  }else{
    program_id = props.param.program_id
  }

  // 画像アップロード中フラグ（）
  let image_upload_flg = ref(false)
    
  //-------- CSVから配列へ変換する ----------------------------------------

  let csv1 = []; // 種類
  let csv2 = []; // テキスト
  let csv3 = []; // 必須フラグ
  let csv4 = [];
  const kaito = (parts) => {
      let part_seq = 1;
            let check_radio_title = "";// チェックボックス or ラジオボタンをグループ化するためのタイトル（check_title、radio_titleの値が挿入）
            let group_seq = 0// チェックボックス or ラジオボタンをグループ化するためのシーケンスNo.
            let set_option = []
            for(let f = 0;f<parts.length;f++){
                
                set_option = []
                let newid = allparts.value.length + 1;

                let syurui = parts[f].syurui
                let flg = parts[f].flg
                let title = parts[f].title
                
                switch(syurui) {
                    case "radio_title":
                        if(parts[f].option){
                            check_radio_title = title
                            part_seq++;
                            group_seq = part_seq
                            for (let p = 0;p<parts[f].option.length;p++){
                                let radio_option = parts[f].option[p]
                                //[["checkbox","学校",[]],["checkbox","その他",["text","その他の場合は入力してください。",""]]]
                                part_seq++;
                                let set_label = radio_option[1]
                                let set_ireko = []
                                if(radio_option[2]){
                                    set_ireko = radio_option[2]
                                    set_ireko[2] = 0 // 表示フラグを非表示にしておく
                                    set_ireko[3] = "" // 入力内容を空にしておく
                                }
                                set_option.push({
                                    index: f,
                                    id: newid,
                                    kind: 'radio',
                                    label: set_label,
                                    seq: "part"+part_seq,
                                    hissu: flg,
                                    title:check_radio_title,
                                    group_seq: "part"+group_seq,
                                    child:set_ireko
                                })

                            }
                            allparts.value.push({
                                id: newid,
                                kind: syurui,
                                label: title,
                                seq: "part"+group_seq,
                                hissu: flg,
                                option:set_option,
                                set_child:[] // 選択された選択肢のパーツ（配列だがラジオボタンなので単一）
                            });
                            
                        }
                        break;
                    case "check_title":
                        check_radio_title = title
                        part_seq++;
                        group_seq = part_seq
                        for (let p = 0;p<parts[f].option.length;p++){
                            let check_option = parts[f].option[p]
                            //[["checkbox","学校",[]],["checkbox","その他",["text","その他の場合は入力してください。"]]]
                            part_seq++;
                            let set_label = check_option[1]
                            let set_ireko = []
                            if(parts[f].option[p]){
                                set_ireko = check_option[2]
                                set_ireko[2] = 0 // 表示フラグを非表示にしておく
                                set_ireko[3] = "" // 入力内容を空にしておく
                            }
                            set_option.push({
                                index: f,
                                id: newid,
                                kind: 'checkbox',
                                label: set_label,
                                seq: "part"+part_seq,
                                hissu: flg,
                                sentaku:false, // このチェックボックスを選択しているかどうか
                                title:check_radio_title,
                                group_seq: "part"+group_seq,
                                child:set_ireko
                            })
                        }
                        console.log(set_option)
                        allparts.value.push({
                            id: newid,
                            kind: syurui,
                            label: title,
                            seq: "part"+group_seq,
                            hissu: flg,
                            option:set_option,
                            set_child:[] // 選択された選択肢のパーツ（チェックボックスなので複数選択肢が入る）
                        });
                        
                        break;
                    case "image":
                        let image_options = [];
                        let url_list = []
                        let image_count = 0;
                        
                        part_seq++;
                        for (let p = 0;p<parts[f].option.length;p++){
                            image_options.push({
                                image_index:(image_count), // 下記セクション内における番号
                                seq:part_seq // 「image」セクションの番号
                            });
                            // 実際にURLを格納する配列に値を追加
                            url_list.push("")
                        }

        
                        allparts.value.push({
                            index: f,
                            id: newid,
                            kind: 'image',
                            label: title,
                            option: image_options,
                            seq: "part"+part_seq,
                            hissu: flg,
                            set_url:url_list
                        });
                        break;
                    case "pulldown": 
                        let options = [];
                        let first_parts = []
                        part_seq++;
                        //part.option[part.selectedIndex]
                        //[["pulldown_child","学校",[]],["pulldown_child","家",[]]]
                        for (let p = 0;p<parts[f].option.length;p++){
                            let set_parts = parts[f].option[p]
                            if( p == 0 ){
                                first_parts = set_parts[1]
                            }
                            options.push(set_parts[1]);
                        }
        
                        allparts.value.push({
                            index: f,
                            id: newid,
                            kind: 'pulldown',
                            label: title,
                            option: options,
                            seq: "part"+part_seq,
                            hissu: flg,
                            set_child:[first_parts], // 選択された選択肢のパーツ（配列だがプルダウンなので単一。初期値は1番上の選択肢）
                            selectedIndex:0 // 選択された選択肢の番地（初期値は1番上を指す0）
                        });
                        break;
                        
                    case "text":
                        part_seq++;
                        let set_mojisu = 0
                        if(parts[f].mojisu) set_mojisu = parts[f].mojisu
                        allparts.value.push({
                            index: f,
                            id: newid,
                            kind: syurui,
                            label: title,
                            seq: "part"+part_seq,
                            hissu: flg,
                            mojisu:set_mojisu,
                            value:"" // 入力内容
                        });
                        break;
                    default:
                        part_seq++;
                        allparts.value.push({
                            index: f,
                            id: newid,
                            kind: syurui,
                            label: title,
                            seq: "part"+part_seq,
                            hissu: flg,
                            value:"" // 入力内容
                        });
                        break;
                }
          }

    emit('call',{cmd:'page_scroll'})
  }
  
  //-------- 回答レコードを作成する ----------------------------
  let answer = ref([]);
  const setText = (index) => {
     let set_text = answer.value[index].replace(/\n/g, '。');
     set_text = set_text.replace(/,/g, '、');
     set_text = set_text.replace(/ /g, '　');
     answer.value[index] = set_text;
  }
  
  const setDate = (index) => {
    //  answer.value[index] = ans_date.value;
  }
  
  const setTime = (index) => {
 //     answer.value[index] = ans_time.value;
  }
   const setCheckbox = (check,group) => {
        let part_id = check.id
        let check_seq = check.seq
        let sentaku = check.sentaku
        // パーツ全体をチェック
        for(let a = 0;a<allparts.value.length;a++){
            // そのチェックボックスのIDなら処理
            if(part_id == allparts.value[a].id){
                // そのチェックボックスのオプション（選択肢配列）を確認
                for (let p=0;p<allparts.value[a].option.length;p++) {
                    // 選択状態の場合
                    if (sentaku == true) {
                        // 選択肢のセクションNo.かどうか確認
                        if(check_seq == allparts.value[a].option[p].seq){
                            // 選択されたものとして「set_child」に格納
                            allparts.value[a].set_child.push(check)
                            // そのセクションNo.の入れ子が存在するなら表示
                            if(allparts.value[a].option[p].child[0] == 'text'){
                                allparts.value[a].option[p].child[2] = 1
                            }
                        }
                    }else{
                        // 未選択状態の場合
                        // そのセクションNo.を持つ配列を削除して詰める
                        allparts.value[a].set_child = allparts.value[a].set_child.filter(item => item.seq !== check_seq)
                        // そのセクションNo.に入れ子がある場合は非表示にする
                        if(check_seq == allparts.value[a].option[p].seq){
                            if(allparts.value[a].option[p].child[0] == 'text'){
                                allparts.value[a].option[p].child[2] = 0
                            }
                        }
                    }
                }
        console.log(allparts.value[a].set_child)
            }
        }


      }

      // チェックボックスの入れ子確認
    const setCheckIreko = (check,group,naiyou) => {
        
        let part_id = check.id
        let check_seq = check.seq
        // パーツ全体をチェック
        for(let a = 0;a<allparts.value.length;a++){
            // そのチェックボックスのIDなら処理
            if(part_id == allparts.value[a].id){
                // そのチェックボックスの選択された選択肢配列を確認
                for (let p=0;p<allparts.value[a].set_child.length;p++) {
                    // 同じセクションNo.を持っていたらチェック
                    if(check_seq == allparts.value[a].set_child[p].seq){
                        // 入れ子（text）属性付きなら配列の4番目（4番地）に内容を入れる
                        if(allparts.value[a].set_child[p].child[0] == 'text'){
                            allparts.value[a].set_child[p].child[3] = naiyou
                        }
                        console.log(allparts.value[a].set_child[p])
                    }
                }
            }
        }

    }
      
  const setChildCheck = (index,child_index) => {
      answer.value[index] = ans_childcheck.value[child_index];
  }

    // parts = ラジオボタン本体、group = ラジオボタンが所属するエリア
    const setRadio = (radio,group) => {
        let part_id = radio.id
        let radio_seq = radio.seq
        
        // パーツ全体をチェック
        for(let a = 0;a<allparts.value.length;a++){
            // そのラジオボタンのIDなら処理
            if(part_id == allparts.value[a].id){
                
                // 選択されたものを空にする
                allparts.value[a].set_child = []
                
                // そのラジオボタンのオプション（選択肢配列）を確認
                for (let p=0;p<allparts.value[a].option.length;p++) {
                    // 入れ子はいったん全部空欄にする
                    allparts.value[a].option[p].child[2] = 0
                    if(radio_seq == allparts.value[a].option[p].seq){
                        // 選択されたものとして「set_child」に格納
                        allparts.value[a].set_child.push(radio)
                        // その選択肢に入れ子が存在するかチェック
                        if(allparts.value[a].option[p].child[0] == 'text'){
                        // 選択肢のセクションNo.なら、入れ子を表示
                            allparts.value[a].option[p].child[2] = 1

                        }
                    }
                }
                console.log(allparts.value[a].set_child)
            }
        }
        
      }
  
  
      // ラジオボタンの入れ子確認
    const setRadioIreko = (radio,group,naiyou) => {
        
        let part_id = radio.id
        let radio_seq = radio.seq
        // パーツ全体をチェック
        for(let a = 0;a<allparts.value.length;a++){
            // そのラジオボタンのIDなら処理
            if(part_id == allparts.value[a].id){
                // そのラジオボタンの選択された選択肢配列を確認
                for (let p=0;p<allparts.value[a].set_child.length;p++) {
                    // 同じセクションNo.を持っていたらチェック
                    if(radio_seq == allparts.value[a].set_child[p].seq){
                        // 入れ子（text）属性付きなら配列の4番目（4番地）に内容を入れる
                        if(allparts.value[a].set_child[p].child[0] == 'text'){
                            allparts.value[a].set_child[p].child[3] = naiyou
                        }
                        console.log(allparts.value[a].set_child[p])
                    }
                }
            }
        }
    }

  const setChildRadio = (index,child_index) => {
      answer.value[index] = ans_childradio.value[child_index];
  }
  
  const setMeasure = (pindex,pdivide,index) => {
      for (let i=0;i<pdivide;i++) {
          answer.value[pindex+i] = '';
      }
      answer.value[index] = '〇';
  }
  const setPulldown = (index) => {
    
    const part = allparts.value[index];
    const selectedOp = part.option[part.selectedIndex];

    // set_child を選択された option に更新
    allparts.value[index].set_child = [selectedOp];

    console.log("選択された option:", allparts.value[index].set_child );
    /*
      for (let i=0;i<allparts.value[index].option.length;i++) {
          if (allparts.value[index].option[i] == ans_pulldown.value) {
              answer.value[index+i+1] = '〇';
          } else {
              answer.value[index+i+1] = '';
          }
      }
        
      answer.value[index] = ""
      
      for (let p=index+1;p<csv1.length;p++) {
            if (csv1[p] != 'pulldown_child') {
                break;
            }

            if(csv2[p] == ans_pulldown.value){
                answer.value[index] = "〇"
                answer.value[p] = "〇"
            }
       }
       */
  }
  
  // 画像をアップロードする
let error_count = 0
const imgUpload = async (e) => {

    // エラー初期化
    error_count = 0;

    const fileInput = e.target;
    console.log(fileInput.id)
    const file = fileInput.files[0];
    // seq：パーツの番地、index：パーツの番地内の「input」の番地

    const file_input_seq = fileInput.id.split(",")[0]
    const file_input_index = fileInput.id.split(",")[1]

    let check_seq = "part"+file_input_seq
    /*
    パーツの構造
    for (let p = 0;p<parts[f].option.length;p++){
                            image_options.push({
                                image_index:(image_count), // 下記セクション内における番号
                                seq:part_seq // 「image」セクションの番号
                            });
                            // 実際にURLを格納する配列に値を追加
                            url_list.push("")
                        }
        
                        part_seq++;
                        allparts.value.push({
                            index: f,
                            id: newid,
                            kind: 'image',
                            label: title,
                            option: image_options,
                            seq: "part"+part_seq,
                            hissu: flg,
                            set_url:url_list
                        });
     */

    if (!file) {

        // ファイルのアップロードを取り消した場合はその番地の回答も空にする

        // パーツ全体を確認
        for(let a = 0;a<allparts.value.length;a++){
            // ファイルをアップロードするパーツと同じセクションNo.であれば処理
            if(allparts.value[a].seq == check_seq){
                // その中の番地のURLを空にする
                allparts.value[a].set_url[file_input_index] = ""
            }
        }
    }else{
    
        // 拡張子取得
        const accept = file.name.split(".").pop();

        // ファイル名作成

        // 種類を取得
        let syurui = "report"
        if(form_syurui == 1){
            syurui = "enqete"
        }

        // fileInput.name = 画像フォーム全体のタイトル部のindex
        let fileNameOnly = GlobalData.shakyo_code+"_"+syurui+form_no+"_"+fileInput.name+"_"+file_input_seq+"_"+file_input_index+"_"+GlobalData.user_id

        // アップロード先のフォルダを指定
        const folder = "form"
        const file_name = `${folder}/${fileNameOnly}.${accept}`;

        // Lambda に送る payload
        const formData = new FormData();
        formData.append("file_name", file_name);
        formData.append("file", file);
        formData.append("Bucket",GlobalData.$Image_bucket)

        try {
            // Lambda API Gateway の URL。APIGatewayではなくLambdaの関数URLを利用
            const set_url = GlobalData.$fileupload_url;

            // 呼び出し
            const response = await axios.post(set_url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            console.log("Lambda response:", response.data);
    //        getImage(response.data.fileUrl)

            for(let a = 0;a<allparts.value.length;a++){
                // ファイルをアップロードするパーツと同じセクションNo.であれば処理
                if(allparts.value[a].seq == check_seq){
                    // その中の番地にURLを挿入する
                    allparts.value[a].set_url[file_input_index] = response.data.fileUrl
                }
            }

        } catch (error) {
            console.error("Upload error:", error);
            error_count++;
        }
    }
};
  
  //-------- CSVに変換する -----------------------
  const csv1_csv = ref('');
  const csv2_csv = ref('');
  const csv3_csv = ref('');
  const answer_csv = ref('');
  let mail_answer = ref('')
  const app = ref('0');
  

  let Uploadparts = [] // アップロードするパーツ
  const teishutsu_kakunin = () => {
    Uploadparts = [] // 初期化


    // メールの内容として送るテキスト（HTML形式）を初期化
    mail_answer.value = ""

    // 必須項目に関するフラグ
    let error_flg = 0 // 必須項目が未入力の場合1
    let text_error_flg = 0 // 文字数指定がされていて、文字数を満たしていない場合は1

    for(let a = 0;a<allparts.value.length;a++){


        let syurui = allparts.value[a].kind // パーツの種類
        let hissu = allparts.value[a].hissu // 必須フラグ
        let label = allparts.value[a].label // 項目のタイトル

      // 一番上のテキスト以外なら改行マークを追加（メール）
      if(a != 0 ) mail_answer.value += "<br><br>"
      
      // パーツのラベルを追加
      mail_answer.value += "● " + label

        switch(syurui) {
            case "check_title":
                // 必須なら中身をチェック
                let check_child = allparts.value[a].set_child // 選択された要素を取得
                if(hissu == 1){
                    if(check_child.length!=0){
                        // チェックボックスセクション内でフラグチェック
                        for(let c = 0;c<check_child.length;c++){
                            if(check_child[c] != "" && check_child[c] != null){
                                // 入れ子がある場合
                                if(check_child[c].child[0] == 'text'){
                                    // 入れ子が入力されていたらOK
                                    if(check_child[c].child[3] != "" && check_child[c].child[3] != null){
                                    }else{
                                        // 何も入力されていないならエラー
                                        error_flg = 1
                                    }
                                }
                            }
                        }
                    }else{
                        // 未入力ならエラー
                        error_flg = 1
                    }
                }
                
                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":check_child})
                
                // 選択肢の内容を追加
                for(let c = 0;c<check_child.length;c++){
                  mail_answer.value += "<br>" + check_child[c].label
                  if(check_child[c].child[0] == 'text'){
                    // 入れ子テキストがあるなら追加
                    mail_answer.value += "<br>" + check_child[c].child[1] +"："+ check_child[c].child[3]
                  }
                }

                break;
            case "radio_title":
            
                let radio_child = allparts.value[a].set_child // 選択された要素を取得
                if(hissu == 1){
                    if(radio_child.length != 0){
                        for(let r = 0;r<radio_child.length;r++){
                            
                            if(radio_child[r] != "" && radio_child[r] != null){
                                // 入れ子がある場合
                                if(radio_child[r].child[0] == 'text'){
                                    // 入れ子が入力されていたらOK
                                    if(radio_child[r].child[3] != "" && radio_child[r].child[3] != null){
                                    }else{
                                        error_flg = 1
                                    }
                                }
                            }
                        }
                    }else{
                        // 未入力ならエラー
                        error_flg = 1
                    }
                }
                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":radio_child})

                // 選択肢の内容を追加
                for(let r = 0;r<radio_child.length;r++){
                  mail_answer.value += "<br>" + radio_child[r].label
                  if(radio_child[r].child[0] == 'text'){
                    // 入れ子テキストがあるなら追加
                    mail_answer.value += "<br>" + radio_child[r].child[1]+"："+ radio_child[r].child[3]
                  }
                }
                break;
            case "pulldown":
                let pulldown_child = allparts.value[a].set_child // 選択された要素を取得
                if(hissu == 1){
                    let pull_flg = 1
                    for(let p = 0;p<pulldown_child.length;p++){
                        
                        if(pulldown_child[p] != "" && pulldown_child[p] != null){
                            pull_flg = 0
                        }
                    }
                    // 未入力のまま（1）ならエラー
                    if(pull_flg == 1){
                        error_flg = 1
                    }
                }
                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":pulldown_child})
                
                // 選択肢の要素を追加
                mail_answer.value += "<br>" + pulldown_child
                break;

            case "image":
                let set_url = allparts.value[a].set_url // アップロードされたURLを取得
                if(hissu == 1){
                    let url_flg = 1
                    for(let s = 0;s<set_url.length;s++){
                        if(set_url[s] != "" && set_url[s] != null){
                            url_flg = 0
                        }
                    }
                    // 未入力のまま（1）ならエラー
                    if(url_flg == 1){
                        error_flg = 1
                    }
                }
                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":set_url})
                
                // 画像はメールで表示できないのでスルー
                mail_answer.value += "<br>※画像は表示できません。"
                break;
            case "text":
                let text = allparts.value[a].value
                // 必須の場合、内容が空ならエラー
                if(hissu == 1){
                    if(text == "" || text == null){
                        error_flg = 1
                    }
                }
                let mojisu = allparts.value[a].mojisu // 項目の文字数指定
                // 0（無限）ではない場合
                if(mojisu != 0){
                    // 文字数指定を満たさない場合はエラー
                    if(mojisu > text.length){
                        text_error_flg = 1
                    }
                }

                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":text,"mojisu":mojisu})
                // 入力された内容を追加
                mail_answer.value += "<br>" + text
                break;
            default:
                let naiyo = allparts.value[a].value
                // 必須の場合、内容が空ならエラー
                if(hissu == 1){
                    if(naiyo == "" || naiyo == null){
                        error_flg = 1
                    }
                }
                Uploadparts.push({"syurui":syurui,"title":label,"flg":hissu,"answer":naiyo})
                // 入力された内容を追加
                mail_answer.value += "<br>" + naiyo
                break;
        }

    }



    console.log(error_flg +"/"+ text_error_flg)

    if(error_flg > 0 || text_error_flg > 0){
        let set_message = ""
        if(error_flg > 0){
            set_message += "未入力の必須項目があります。"
        }
        if(text_error_flg > 0){
            if(set_message != "") set_message += "<br>"
            set_message += "文字数を満たさない項目があります。"
        }
        message.value = set_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "get_error";
        contentMessage.value = MessageModal
    }else{
        
        if(teishutsu_flg.value == 0){
            message.value = "提出しますか？";
            message_cat.value = 1;
            message_flag.value = true;
            message_method.value = "teishutsu_kakunin";
            contentMessage.value = MessageModal

        }
        
    }
  }

  let teishutsu_flg = ref(0)

  const teishutsu  = () => {

    if(teishutsu_flg.value == 0){
        teishutsu_flg.value = teishutsu_flg.value + 1
        emit('call',{cmd:'cr_answer',
                "form_title":results.title,
                "form_id":results.form_id,
                "form_no":form_no,
                "program_id":program_id,
                "form_syurui":form_syurui,
                "answer_list":Uploadparts,
                "mail_answer":mail_answer.value,
                "moshikomi_count":moshikomi_count});
    }
  }

  // アンケート提出済みが確認
  let answer_check_error = 0
  let Form_answer_check = function() { 
    
      let set_url = GlobalData.$API_URL+ "Form_Dynamo_read"
      axios.post(set_url,
      {
        action:"get_form_answers",
        choson_code:route.params.shakyo,
        taikenuser_id:GlobalData.user_id
      }).then(response => {

            console.log(response.data.data)

            if(response.data.data){
                // フラグ
                let ok_flg = 0

                for(let i = 0;i<response.data.data.length;i++){
                    let form_data = response.data.data[i]
                    // 種類がアンケート、かつ、フォームNo.が1（ユーザー登録後アンケート）なら回答済みと判断
                    if(form_data.syurui == "enqete" && form_data.form_no == 1){
                        ok_flg = 1
                    }
                }
                
                if(ok_flg == 1){
                  message.value = "あなたはすでにこのアンケートを回答しています。";
                  message_cat.value = 0;
                  message_flag.value = true;
                  message_method.value = "enqete_ok";
                  contentMessage.value = MessageModal
                }
            }

            })
            .catch(error => {
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            })
  }

    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

        if(message_method.value == "not_form"){
          // アンケート・報告書の内容が用意されていないときはマイページに戻す
          location.href = location.protocol+'//'+location.host+'/'+route.params.shakyo+'/Taiken/mypage'
        }else if(message_method.value == "teishutsu_kakunin"){
          teishutsu()
        }else if(message_method.value == "enqete_ok"){
          // アンケート回答済みの場合はHOMEへ戻す
          location.href = location.protocol+'//'+location.host+'/'+route.params.shakyo+'/Taiken'
        }
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

  
    /* 初期処理 */
    if(form_syurui == 1){
      // アンケート提出済みか確認
      Form_answer_check()
    }
    kaito(results.parts);
  </script>
  
  <style scoped>
  td {
      border: none;
  }
    
    .answer_area div{
    width:100%
    }

    .answer_area div textarea{
    width:100%
    }

    .section_area{
    background-color: white;
        box-shadow: 1px 1px 3px black;
        padding: 1rem;
            margin-bottom: 22px;
            font-size:0.95rem;
        border-radius: 5px;
    }


    .section_area input[type=radio]{
    background-color: #eeeeee;
    }
    .section_area input:checked[type=radio]{
    background-color: blue;
    }
.title_set {
  padding-left:0
}

  </style>
  